import { z } from 'zod'
const jsonObject = z.record(z.unknown())
export const billingMoneySyntheticProofResponseSchema = jsonObject
export type BillingMoneySyntheticProofResponse = z.infer<typeof billingMoneySyntheticProofResponseSchema>
